import React from 'react';
import { ATTENDANCE_RANGES, EVENT_TYPES, INPUT, LABEL } from './quoteOptions';

const SELECT_STYLE = {
  backgroundImage:
    'url("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2300b8ff%27 stroke-width=%272.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27><polyline points=%276 9 12 15 18 9%27/></svg>")',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 14px center',
};

export function Select({ id, label, value, onChange, options, placeholder, error, testid }) {
  return (
    <div>
      <label className={LABEL} htmlFor={id}>{label}</label>
      <select
        id={id}
        value={value}
        onChange={onChange}
        className={`${INPUT} appearance-none pr-10 cursor-pointer ${error ? 'border-red-500/60' : ''}`}
        style={SELECT_STYLE}
        data-testid={testid}
      >
        <option value="">{placeholder}</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
      {error && <p className="text-xs text-red-400 mt-1">{error}</p>}
    </div>
  );
}

export default function EventFields({ form, update, errors }) {
  return (
    <div className="rounded-xl border border-[#00b8ff]/30 bg-[#00b8ff]/[0.04] p-5 md:p-6" data-testid="quote-event-fields">
      <p className="text-xs uppercase tracking-[0.2em] text-[#00b8ff] mb-4">Live event details</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <Select id="q-event-type" label="Event type *" value={form.event_type} onChange={update('event_type')} options={EVENT_TYPES} placeholder="Select event type" error={errors.event_type} testid="quote-event-type" />
        <div>
          <label className={LABEL} htmlFor="q-event-date">Event date *</label>
          <input id="q-event-date" type="date" value={form.event_date} onChange={update('event_date')} className={`${INPUT} [color-scheme:dark] ${errors.event_date ? 'border-red-500/60' : ''}`} data-testid="quote-event-date" />
          {errors.event_date && <p className="text-xs text-red-400 mt-1">{errors.event_date}</p>}
        </div>
        <Select id="q-attendance" label="Expected attendance" value={form.attendance} onChange={update('attendance')} options={ATTENDANCE_RANGES} placeholder="Select range" testid="quote-attendance" />
      </div>
    </div>
  );
}
